import { AxiosResponse } from "axios";
import { DynamicCsvRequest } from "../../Model/Dto/DynamicCsv";
import * as ApiUrls from "./ApiUrl.Csv";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";

export const DynamicCsvService = {
    GenerateCsv: (request: DynamicCsvRequest): Promise<AxiosResponse<any>> => axiosCoreInstance.post(ApiUrls.csv, request),

}